import { writeJson } from '@ms-cloudpack/json-utilities';
import type { AppConfig } from '@ms-cloudpack/common-types';
import { getConfigPath } from '../getConfigPath.js';
import { appConfigSchemaUrl } from '../constants.js';

/**
 * Writes updates to the user config JSON.
 * This is ONLY used when creating a default app config or by tests.
 * @param customConfigFileName - optional custom config file name to use instead of defaults
 */
export async function writeAppConfig(config: AppConfig, appPath: string, customConfigFileName?: string): Promise<void> {
  const { defaultAppConfigPath } = getConfigPath(appPath, customConfigFileName);

  return writeJson(
    defaultAppConfigPath,
    {
      $schema: appConfigSchemaUrl,
      ...config,
    },
    { update: true, mode: 'permissive' },
  );
}
